// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {Chip} from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';

import {colors} from '../../assets/styles/colors';

type TagType =
  | 'warning'
  | 'success'
  | 'danger'
  | 'info'
  | 'default'
  | 'primary';
type Props = {
  label: string,
  type?: TagType,
  flat?: boolean,
};

const getColorByType = (type: TagType) => {
  let color = '';
  switch (type) {
    case 'danger':
      color = colors.danger;
      break;
    case 'success':
      color = colors.success;
      break;
    case 'warning':
      color = colors.warning;
      break;
    case 'info':
      color = colors.info;
      break;

    case 'primary':
      color = colors.primary;
      break;

    default:
      color = colors.grey900;
      break;
  }

  return {
    lightColor: `${color}33`,
    color,
  };
};

const useStyles = ({type, flat}) =>
  makeStyles({
    root: {
      background: () => {
        const {color, lightColor} = getColorByType(type);
        return flat ? lightColor : color;
      },
      fontWeight: 600,
      borderRadius: 4,

      '& span': {
        fontSize: '0.875rem',
        color: () => {
          const {color} = getColorByType(type);
          return flat ? color : 'white';
        },
      },
    },
  });

export default function Tag(props: Props) {
  const {label, flat = false, type = 'default'} = props;
  const classes = useStyles({type, flat})();

  return <Chip label={label} size="small" className={classes.root} />;
}

Tag.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['warning', 'success', 'danger', 'info', 'default']),
};
